export default "__VITE_ASSET__9faba841__"